import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { History } from 'history';

import { receiveError } from '../../store/actions/notificationAction';
import { openTermsModal } from '../../store/actions/termsAndConditionsModalAction';

import forwarderRemote from '../../api/forwarderRemote';
import ghaRemote from '../../api/ghaRemote';
import userRemote from '../../api/userRemote';

import Register from './Register';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';

import RegisterModel from '../../models/Register';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { UserRoleType } from '../../models/User';

interface RegisterProps { 
  history: History; 
  redirect: Function;
  receiveError: (error: ResponseError) => void;
  showTerms: () => void;
};

interface RegisterState { 
  modalOpen: boolean;
  fields: RegisterModel;
  companyValue: string;
  companies: Array<{id: number, name: string, role: string}>;
  errorFields: { email: string, passwordRepeat: string };
};

class RegisterContainer extends Component<RegisterProps, RegisterState> {

  state: RegisterState = {
    modalOpen: false,
    fields: { 
      firstName: '', 
      lastName: '',
      tel: '',
      email: '',
      password: '',
      passwordRepeat: '',
      companyId: -1,
      role: '',
      terms: false
      },
    companyValue: '',
    companies: [],
    errorFields: { 
      email: '',
      passwordRepeat: '',
    },
  };

  componentDidMount () {
    this.loadCompanies();
  }

  loadCompanies = () => {
    let companies: Array<{id: number, name: string, role: string}> = [];

    forwarderRemote.getForwarders({}).then((resp: ApiResponse<Array<{id: number, name: string}>>) => {

      const companiesFwd: Array<{id: number, name: string}> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;      

      if (companiesFwd) {
        const arrFwd = companiesFwd.map(arr => ({...arr, role: UserRoleType.FORWARDER }))
        Array.prototype.push.apply(companies,arrFwd);
        this.setState({ companies });
      }
      
      if (error) {
        this.props.receiveError(error);
      };
    });

    ghaRemote.getGHAs().then((resp: ApiResponse<Array<{id: number, name: string}>>) => {

      const companiesGha: Array<{id: number, name: string}> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (companiesGha) {
        const arrGha = companiesGha.map(arr => ({ ...arr, role: UserRoleType.GHA }))
        Array.prototype.push.apply(companies,arrGha);
        this.setState({ companies });      
      }
      
      if (error) {
        this.props.receiveError(error);
      };
    });
   
  };


  handleChange = (event: any): void => {

    const name = event.target.name
    const fields: RegisterModel = { ...this.state.fields };
    const value = event.target.value;

    switch(name) {
      case 'first_name':
        fields.firstName = value;
        break;
      case 'last_name':
        fields.lastName =value;
        break;
      case 'tel':
        fields.tel =value;
        break;
      case 'email':
        fields.email = value;
        break;
      case 'password':
        fields.password = value;
        break;
      case 'password_repeat':
        fields.passwordRepeat = value;
        break;
      case 'terms':
        fields.terms = !fields.terms;
        break;
      default: break;
    }
    this.setState({ fields });
  }

  selectCompany = (event: any): void => {
    const companyValue = event.target.value;
    const arr = companyValue.split('_');
    const fields: RegisterModel = { ...this.state.fields };
    fields.companyId = +arr[1];
    fields.role = arr[0];
    this.setState({ fields, companyValue } )
  }

  handleSubmit = (event: any): void => {
    event.preventDefault();

    if(this.handleValidation()) {

      userRemote.register(this.state.fields).then((resp: ApiResponse<boolean>) => {

        const success: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;
  
        if (success) {
          this.setState({ modalOpen: true }); 
        }
        
        if (error) {
          this.props.receiveError(error);
        };
      });
          
    };
  };

  handleValidation = (): boolean => {

    const fields: RegisterModel = { ...this.state.fields };
    const errors: any = { ... this.state.errorFields };
    const emailRegex: RegExp = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/);
    let formIsValid: boolean = true;

    if (typeof fields.email !== "undefined") {

        if (!emailRegex.test(fields.email)) {
            formIsValid = false;
            errors.email = "Email format is not valid.";
        }
    }

    if((fields.password).trim() !== (fields.passwordRepeat).trim()) {
      formIsValid = false;
      errors.passwordRepeat = "the passwords are not the same";
    }
   
    this.setState({ errorFields: errors });

    return formIsValid;
  }
  confirm = () => {
    this.props.history.push('/login');
  }

  render() {

    return (
      <Fragment>
        <Register
          change={ this.handleChange }
          submit={ this.handleSubmit }
          fields={ this.state.fields }
          errorFields={ this.state.errorFields }
          selectCompany={ this.selectCompany }
          companies={ this.state.companies }
          companyValue={ this.state.companyValue }
          termsAndConditionsOnClick={() => {this.props.showTerms();}}
        />
        { this.state.modalOpen &&
          <ConfirmationDialog
            open={ this.state.modalOpen }
            title=''
            text='Your registration is successfully. You are going to receive email to confirm it'
            close={() => { this.setState({ modalOpen: false }) }}
            confirm={ this.confirm }
            textConfirm='OK'
            showCloseIcon={ true }
          /> 
        }
      </Fragment>
    );
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    showTerms: () => dispatch(openTermsModal(true))
  };
};


export default connect(null, mapDispatchToProps)(RegisterContainer);